import { createFileRoute, redirect } from '@tanstack/react-router';
import { DppQrCodeTab } from '@/app/(client)/my-styles/-components/DppQrCodeTab';
import {
  type EntityKindPath,
  isEntityKindPath,
  useEntityDetail,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/qr-code',
)({
  beforeLoad: async ({ params }) => {
    const perms = await ensurePermissions();
    if (!perms['digital-products-passport'].canRead) {
      throw redirect({
        to: '/my-styles/$kind/$id/overview',
        params: { kind: params.kind, id: params.id },
      });
    }
  },
  component: DppQrCodeRoute,
});

function DppQrCodeRoute() {
  // Parent `$kind/$id/route.tsx` validates `kind` and redirects on invalid
  // values, so by the time this renders the cast is safe.
  const { kind, id } = Route.useParams() as {
    kind: EntityKindPath;
    id: string;
  };
  const { data: entity } = useEntityDetail(kind, id);
  if (!isEntityKindPath(kind)) return null;
  return (
    <DppQrCodeTab
      qrCodeUrl={entity?.qrCodeUrl}
      entityName={entity?.name ?? ''}
    />
  );
}
